export const LLM_STATUS = { GOOD: 'Good', BAD: 'Bad', NONE: 'None' };

export const COST_STRUCTURE = {
     PAY_FOR_ALL: 'payForAll',
     PAY_FOR_GOOD: 'payForGood',
};

export const COST_STRUCTURE_B2B = [
     { label: 'Pay for All B2B matches (Good or Poor)', value: COST_STRUCTURE.PAY_FOR_ALL},
     { label: 'Pay only for B2B Good Match', value: COST_STRUCTURE.PAY_FOR_GOOD},
];

export const COST_STRUCTURE_B2C = [
     { label: 'Pay for All B2C matches (Good or Poor)', value: COST_STRUCTURE.PAY_FOR_ALL},
     { label: 'Pay only for B2C Good Match', value: COST_STRUCTURE.PAY_FOR_GOOD},
];

export const ENRICHMENT_FIELD = {
     NOT_ATTEMPT: 'Not Attempt',
     NO_MATCH: 'No Match',
     POOR_MATCH: 'Poor Match',
     GOOD_MATCH: 'Good Match',
};

export const ENRICHMENT_OPTIONS = [
     { label: ENRICHMENT_FIELD.NOT_ATTEMPT, value: ENRICHMENT_FIELD.NOT_ATTEMPT },
     { label: ENRICHMENT_FIELD.NO_MATCH, value: ENRICHMENT_FIELD.NO_MATCH },
     { label: ENRICHMENT_FIELD.POOR_MATCH, value: ENRICHMENT_FIELD.POOR_MATCH },
     { label: ENRICHMENT_FIELD.GOOD_MATCH, value: ENRICHMENT_FIELD.GOOD_MATCH },
];

export const ENRICHMENT_COLOR = {
     [ENRICHMENT_FIELD.GOOD_MATCH]: 'success',
     [ENRICHMENT_FIELD.POOR_MATCH]: 'warning',
     [ENRICHMENT_FIELD.NO_MATCH]: 'danger',
     [ENRICHMENT_FIELD.NOT_ATTEMPT]: 'secondary'
};

export const ENRICHMENT_ICON = {
     [ENRICHMENT_FIELD.GOOD_MATCH]: <i className="fas fa-check text-green"></i>,
     [ENRICHMENT_FIELD.POOR_MATCH]: <i className="fas fa-minus-circle text-yellow-500"></i>,
     [ENRICHMENT_FIELD.NO_MATCH]: <i className="fas fa-times-circle text-red-500"></i>,
     [ENRICHMENT_FIELD.NOT_ATTEMPT]: ''
};

export const ENRICHMENT_DESCRIPTION_B2B = {
     [ENRICHMENT_FIELD.GOOD_MATCH]: 'B2B enrichment has occurred for this person and resulted in a Good Match',
     [ENRICHMENT_FIELD.POOR_MATCH]: 'B2B enrichment has occurred for this person and resulted in a Poor Match',
     [ENRICHMENT_FIELD.NO_MATCH]: 'B2B enrichment has occurred for this person and resulted in No Match found',
     [ENRICHMENT_FIELD.NOT_ATTEMPT]: 'The person has not been enriched with B2B profile data'
};

export const ENRICHMENT_DESCRIPTION_B2C = {
     [ENRICHMENT_FIELD.GOOD_MATCH]: 'B2C enrichment has occurred for this person and resulted in a Good Match',
     [ENRICHMENT_FIELD.POOR_MATCH]: 'B2C enrichment has occurred for this person and resulted in a Poor Match',
     [ENRICHMENT_FIELD.NO_MATCH]: 'B2C enrichment has occurred for this person and resulted in No Match found',
     [ENRICHMENT_FIELD.NOT_ATTEMPT]: 'The person has not been enriched with B2C profile data'
};
